import { RefObject, useEffect, useRef } from 'react'

const useClickOutside = (handler: () => void): RefObject<HTMLElement | null> => {
  const domNodeRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    const callHandler = (event: MouseEvent) => {
      if (!domNodeRef?.current?.contains(event.target as HTMLElement)) {
        handler()
      }
    }

    document.addEventListener('click', callHandler)

    return () => {
      document.removeEventListener('click', callHandler)
    }
  })

  return domNodeRef
}

export default useClickOutside
